import React, { useState } from 'react';
import CasesAPI from 'api/CasesAPI';
import { getDateDifference } from 'utils/dateFormater';
interface AuditType {
  handleTooltipClick?: () => void;
  comments: any;
  addComment: any;
  removeComment: any;
  cur_user: any;
  cur_case: any;
  trigger: boolean;
  setTrigger: any;
}

const CommentsModal: React.FC<AuditType> = ({
  handleTooltipClick,
  comments,
  addComment,
  removeComment,
  cur_user,
  cur_case,
  trigger,
  setTrigger,
}) => {
  const [ content, setContent ] = useState('');
  const [ editedCommentIndex, setEditedCommentIndex ] = useState<number | null>();
  const [ editedMessage, setEditedMessage ] = useState('');

  const handleEditClick = (index: number, currentContent: any) => {
    setEditedCommentIndex(index);
    setEditedMessage(currentContent);
  };

  const handleSave = async(index: number) => {
    comments[index].content = editedMessage;
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: 'edited a comment',
      timeStamp: Date.now(),
    };
    const update: any = {
      _id: cur_case.data._id,
      comments: [ ...comments ],
      activity: [ ...cur_case.data.activity, actObj ],
    };
    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
    setEditedCommentIndex(null);
  };

  const handleComment = () => {
    if (content.length > 0) {
      addComment(content);
      setContent('');
    }
  };
  const handleMessageChange = (e: any) => {
    const { value } = e.target;
    setEditedMessage(value);
  };

  const handleChange = (e: any) => {
    setContent(e.target.value);
  };

  const handleEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.which === 13) {
      if (content.length > 0) {
        addComment(content);
        setContent('');
      }
    }
  };

  const handleDelete = (id: string) => {
    const arr = comments.filter((com: any) => com._id !== id);
    removeComment(arr);
  };

  const checkAuthor = (name: string) => {
    if (
      name === `${cur_user?.basics?.firstName} ${cur_user?.basics?.lastName}`
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className='comments-panel'>
        <div className='comments-panel-header'>
          <div className='comments-panel-header-cont'>
            <div className='comments-panel-header-cont-head'>
              <div className='comments-panel-header-cont-head-text'>
                <h1>Comments</h1>
                <p>Leave any document comments here.</p>
              </div>
            </div>
            <div className='comments-panel-header-cont-btn' onClick={handleTooltipClick}>
              <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                <path d='M15 5L5 15M5 5L15 15' stroke='var(--card-text)' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
          </div>
        </div>
        <div className='comments-panel-body'>
          <div className='comments-panel-body-section'>
            <div className='comments-panel-body-section-feed'>
              {comments.map((comment: any, i: number) => (
                <div className='comments-panel-body-section-feed-item' key={i}>
                  <div className='comments-panel-body-section-feed-cont'>
                    <div className='comments-panel-body-section-feed-cont-text'>
                      <div className='comments-panel-body-section-feed-cont-text-sec'>
                        <h2>{comment.person}</h2>
                        <p>{getDateDifference(comment.date)}</p>
                        {editedCommentIndex === i ?
                          <svg onClick={() => {
                            handleSave(i);
                            // setEditedMessage(editedMessage);
                          }} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                            <path d='M12.5 6.66667H7.16667C6.69996 6.66667 6.4666 6.66667 6.28834 6.57584C6.13154 6.49594 6.00406 6.36846 5.92416 6.21166C5.83333 6.0334 5.83333 5.80004 5.83333 5.33333V2.5M14.1667 17.5V12.1667C14.1667 11.7 14.1667 11.4666 14.0758 11.2883C13.9959 11.1315 13.8685 11.0041 13.7117 10.9242C13.5334 10.8333 13.3 10.8333 12.8333 10.8333H7.16667C6.69996 10.8333 6.4666 10.8333 6.28834 10.9242C6.13154 11.0041 6.00406 11.1315 5.92416 11.2883C5.83333 11.4666 5.83333 11.7 5.83333 12.1667V17.5M17.5 7.77124V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5H12.2288C12.6364 2.5 12.8402 2.5 13.0321 2.54605C13.2021 2.58688 13.3647 2.65422 13.5138 2.7456C13.682 2.84867 13.8261 2.9928 14.1144 3.28105L16.719 5.88562C17.0072 6.17387 17.1513 6.318 17.2544 6.48619C17.3458 6.63531 17.4131 6.79789 17.4539 6.96795C17.5 7.15976 17.5 7.36358 17.5 7.77124Z' stroke='var(--card-text)' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                          </svg> : <svg onClick={() => {
                            handleEditClick(i, comment.content);
                          }} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                            <path d='M9.99998 16.6667H17.5M2.5 16.6667H3.89545C4.3031 16.6667 4.50693 16.6667 4.69874 16.6206C4.8688 16.5798 5.03138 16.5125 5.1805 16.4211C5.34869 16.318 5.49282 16.1739 5.78107 15.8856L16.25 5.41669C16.9404 4.72634 16.9404 3.60705 16.25 2.91669C15.5597 2.22634 14.4404 2.22634 13.75 2.91669L3.28105 13.3856C2.9928 13.6739 2.84867 13.818 2.7456 13.9862C2.65422 14.1353 2.58688 14.2979 2.54605 14.468C2.5 14.6598 2.5 14.8636 2.5 15.2713V16.6667Z' stroke='var(--card-text)' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                          </svg>}
                        {checkAuthor(comment.person) && (
                          <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' onClick={() => handleDelete(comment._id)} style={{ cursor: 'pointer' }}>
                            <path d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167' stroke='var(--card-text)' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                          </svg>
                        )}
                      </div>
                    </div>
                    {editedCommentIndex === i ? (
                      <div className='autoName-container'>
                        <textarea
                          id='primary'
                          className='autoName-content'
                          name='primary'
                          value={editedMessage}
                          onChange={(e) => handleMessageChange(e)}
                        />
                      </div>
                    ) : (
                      <div className='comments-panel-body-section-feed-cont-msg'>
                        <div className='comments-panel-body-section-feed-cont-msg-text'>
                          {comment.content}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='comments-panel-footer'>
          <div className='comments-panel-footer-cont'>
            <div className='comments-panel-footer-cont-action'>
              <textarea
                placeholder='Comment'
                onKeyUp={handleEnterPress}
                onChange={handleChange}
                value={content}
                className='comments-panel-footer-cont-action-input-cont'
              />
            </div>
            <div className='comments-panel-footer-cont-btn'>
              <div className='comments-panel-footer-cont-btn-cmd'>
                <div className='comments-panel-footer-cont-btn-cmd-key'>
                  ↵/Enter
                </div>
              </div>
              <div className='comments-panel-footer-cont-btn-or'>or</div>
              <div
                className='comments-panel-footer-cont-btn-act'
                onClick={handleComment}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                >
                  <path
                    d='M8.74976 11.2501L17.4998 2.50014M8.85608 11.5235L11.0462 17.1552C11.2391 17.6513 11.3356 17.8994 11.4746 17.9718C11.5951 18.0346 11.7386 18.0347 11.8592 17.972C11.9983 17.8998 12.095 17.6518 12.2886 17.1559L17.7805 3.08281C17.9552 2.63516 18.0426 2.41133 17.9948 2.26831C17.9533 2.1441 17.8558 2.04663 17.7316 2.00514C17.5886 1.95736 17.3647 2.0447 16.9171 2.21939L2.84398 7.71134C2.34808 7.90486 2.10013 8.00163 2.02788 8.14071C1.96524 8.26129 1.96532 8.40483 2.0281 8.52533C2.10052 8.66433 2.34859 8.7608 2.84471 8.95373L8.47638 11.1438C8.57708 11.183 8.62744 11.2026 8.66984 11.2328C8.70742 11.2596 8.74028 11.2925 8.76709 11.3301C8.79734 11.3725 8.81692 11.4228 8.85608 11.5235Z'
                    stroke='var(--text-primary)'
                    strokeWidth='1.66667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommentsModal;
